import { GDriveFile, GDriveMatchingTableRow } from 'infrastructure/googleDrive'
import { parseFilenameByFormat } from './utility'
import { createData } from 'components/tree/googleApis/components/GDriveMatchingTable'

export function generateRows(
  files: GDriveFile[],
  regex: RegExp,
  format: string,
): GDriveMatchingTableRow[] {
  const rows = files.map((file) => {
    const parsedData = parseFilenameByFormat(file.name, regex, format)
    if (!parsedData) {
      return null
    }
    return createData(
      file.name,
      parseInt(parsedData.grade),
      parseInt(parsedData.unit),
      parseInt(parsedData.lesson),
      file as GDriveFile,
    )
  })

  return (rows.filter((row) => row !== null) || []) as GDriveMatchingTableRow[]
}
